export default __webpack_public_path__ + "img/c72369cd30af3546e919f122b772ca0c.png";